import type { Messages } from '../i18n/messages';

/**
 * Kubernetes fleet-overview + Workloads section chrome. Node/pod/cluster
 * names, k8s condition/reason strings (Ready/NotReady, CrashLoopBackOff,
 * namespace names, cluster names) are raw domain data — see clusterStats.ts —
 * and are never keyed here.
 */
export const kubernetesMessages: Messages = {
  'kubernetes.page.title': { en: 'Kubernetes', fun: 'Kubernetes' },
  'kubernetes.page.description': {
    en: 'Cluster and node health across the Regask AKS fleet',
    fun: 'Vibe check for every cluster and node in the Regask AKS fleet',
  },
  'kubernetes.page.refreshTooltip': {
    en: 'Refreshes Kubernetes cluster summaries now. Auto refresh runs every 30s while this page is visible and pauses when the browser tab is hidden.',
    fun: 'Pokes every cluster for a fresh summary right now. Auto-refreshes every 30s while this tab is open, naps when it is not.',
  },
  'kubernetes.page.loadingClusters': {
    en: 'Loading clusters…',
    fun: 'Rounding up the clusters…',
  },
  'kubernetes.page.listError': {
    en: 'Could not list clusters — is the Kubernetes backend configured?',
    fun: 'Cluster roll call failed — is the Kubernetes backend even plugged in?',
  },
  'kubernetes.page.noClusters': {
    en: 'No clusters configured — add them under `kubernetes` in app-config.',
    fun: 'No clusters here — add some under `kubernetes` in app-config.',
  },
  'kubernetes.clusterCard.loading': {
    en: 'Loading cluster…',
    fun: 'Spinning up cluster details…',
  },
  'kubernetes.clusterCard.unreachable': {
    en: 'cluster unreachable — check credentials',
    fun: 'cluster gone quiet — check your credentials',
  },
  'kubernetes.clusterCard.noNodes': {
    en: 'No nodes reported by the cluster.',
    fun: 'The cluster reported zero nodes. Suspicious.',
  },
  'kubernetes.clusterCard.up': { en: 'Up', fun: 'Up' },
  'kubernetes.clusterCard.down': { en: 'Down', fun: 'Down' },
  'kubernetes.clusterCard.nodeCount': {
    en: '{count} nodes',
    fun: '{count} nodes on deck',
  },
  'kubernetes.nodesTable.node': { en: 'Node', fun: 'Node' },
  'kubernetes.nodesTable.status': { en: 'Status', fun: 'Status' },
  'kubernetes.nodesTable.pods': { en: 'Pods', fun: 'Pods' },
  'kubernetes.nodesTable.cpu': { en: 'CPU', fun: 'CPU' },
  'kubernetes.nodesTable.memory': { en: 'Memory', fun: 'Memory' },
  'kubernetes.nodesTable.kubelet': { en: 'Kubelet', fun: 'Kubelet' },
  'kubernetes.nodesTable.age': { en: 'Age', fun: 'Age' },
  'kubernetes.problemPods.title': {
    en: 'Problem pods',
    fun: 'Pods in trouble',
  },
  'kubernetes.problemPods.column.pod': { en: 'Pod', fun: 'Pod' },
  'kubernetes.problemPods.column.node': { en: 'Node', fun: 'Node' },
  'kubernetes.problemPods.column.reason': { en: 'Reason', fun: 'Excuse' },
  'kubernetes.problemPods.column.restarts': {
    en: 'Restarts',
    fun: 'Restarts',
  },
  'kubernetes.problemPods.column.age': { en: 'Age', fun: 'Age' },
  'kubernetes.problemPods.andMore': {
    en: 'and {count} more',
    fun: 'plus {count} more lurking',
  },
  'kubernetes.workloads.title': { en: 'Workloads', fun: 'Workloads' },
  'kubernetes.workloads.description': {
    en: 'Stock Kubernetes plugin view of every labeled workload, per environment namespace',
    fun: 'The stock Kubernetes view of every labeled workload, one environment at a time',
  },
  'kubernetes.workloads.env.development': {
    en: 'Development',
    fun: 'Development',
  },
  'kubernetes.workloads.env.staging': { en: 'Staging', fun: 'Staging' },
  'kubernetes.workloads.env.prePprod': { en: 'Pre-prod', fun: 'Pre-prod' },
  'kubernetes.workloads.env.production': {
    en: 'Production',
    fun: 'Production',
  },
  'kubernetes.workloads.tabSubtitle': {
    en: '{cluster} cluster · {env} namespace',
    fun: '{cluster} cluster · {env} namespace',
  },
};
